import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '../app-settings';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  private formHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }),
  };

  constructor(private http: HttpClient) {}

  createOrderTPV(data: any) {
    return this.http
      .post<any>(AppSettings.API_URI_V2 + '/admin/order/tpv', data)
      .pipe(
        map((data) => {
          return data;
        })
      );
  }
}
